var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"project-logo"},[_c('img',{staticClass:"project-logo__img",attrs:{"src":_vm.pathImg}})])
}
var staticRenderFns = []

export { render, staticRenderFns }